module.exports = __webpack_public_path__ + "static/media/materialList.9c01e021.txt";